import React from "react";
import { PToastStyle as S } from "./PToast.style";
import { Toast, ToastProps } from "primereact/toast";

export const PToast = React.forwardRef<Toast, ToastProps>((props, ref) => <S.Toast {...props} ref={ref} />);
